import { createFileRoute } from "@tanstack/react-router";

import { collectionsTabSearchSchema } from "@/features/datasource/lib/data-resource-search";
import { getCollectionFiltersOptions } from "@/openapi/@tanstack/react-query.gen";

export const Route = createFileRoute("/_protected/data/collections")({
  validateSearch: collectionsTabSearchSchema,
  loader: ({ context: { queryClient, ...context } }) => {
    const orgId = context.user.organization?.id;
    if (!orgId) {
      throw new Error("Organization ID not found");
    }

    void queryClient.query({
      ...getCollectionFiltersOptions({
        path: {
          org_id: orgId,
        },
      }),
      staleTime: "static",
    });
  },
});
